import { useQuery } from '@tanstack/react-query';
import { getTRSRegistration } from '@/API/TRSRegistration/getTRSRegistration';

const useGetTRSRegistration = (registrationID) => {
    return useQuery({
        queryKey: ['TRSRegistration', registrationID],
        queryFn: async () => {
            try {
                const response = await getTRSRegistration(registrationID);
                return response.data;
            } catch (error) {
                console.error('Error fetching TRS registration:', error);
                throw error;
            }
        },
        enabled: !!registrationID,
        staleTime: 0,
        cacheTime: 0,
        refetchOnWindowFocus: false,
        retry: 3,
    });
};

export default useGetTRSRegistration;
